import type { Item, Category, DashboardStats } from '../types';

export const mockItems: Item[] = [
  {
    id: 1,
    name: 'Electric Kettle',
    category: 'Kitchen > Appliances',
    low_price: 299.0,
    medium_price: 449.0,
    high_price: 699.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: ['https://example.com/kettle-1', 'https://example.com/kettle-2'],
    confidence_score: 0.85,
    tags: ['kitchen', 'appliance', 'electric'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 2,
    name: 'Microwave Oven',
    category: 'Kitchen > Appliances',
    low_price: 899.0,
    medium_price: 1499.0,
    high_price: 2499.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: ['https://example.com/microwave-1'],
    confidence_score: 0.92,
    tags: ['kitchen', 'appliance', 'cooking'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 3,
    name: 'Toaster',
    category: 'Kitchen > Appliances',
    low_price: 199.0,
    medium_price: 349.0,
    high_price: 599.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.78,
    tags: ['kitchen', 'appliance', 'breakfast'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 4,
    name: 'Blender',
    category: 'Kitchen > Appliances',
    low_price: 399.0,
    medium_price: 799.0,
    high_price: 1299.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.88,
    tags: ['kitchen', 'appliance', 'food-prep'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 5,
    name: 'Coffee Maker',
    category: 'Kitchen > Appliances',
    low_price: 499.0,
    medium_price: 899.0,
    high_price: 1599.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.82,
    tags: ['kitchen', 'appliance', 'coffee'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 6,
    name: 'Air Fryer',
    category: 'Kitchen > Appliances',
    low_price: 799.0,
    medium_price: 1299.0,
    high_price: 2199.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.9,
    tags: ['kitchen', 'appliance', 'cooking'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 7,
    name: 'Lawn Mower',
    category: 'Garden > Tools',
    low_price: 1999.0,
    medium_price: 3499.0,
    high_price: 5999.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.75,
    tags: ['garden', 'outdoor', 'lawn'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 8,
    name: 'Vacuum Cleaner',
    category: 'Cleaning > Appliances',
    low_price: 1299.0,
    medium_price: 2499.0,
    high_price: 4999.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.88,
    tags: ['cleaning', 'appliance', 'floor'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 9,
    name: 'Washing Machine',
    category: 'Laundry > Appliances',
    low_price: 3999.0,
    medium_price: 6499.0,
    high_price: 9999.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.95,
    tags: ['laundry', 'appliance', 'large'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 10,
    name: 'Television 55 inch',
    category: 'Living Room > Electronics',
    low_price: 4999.0,
    medium_price: 7999.0,
    high_price: 12999.0,
    currency: 'ZAR',
    last_updated: new Date().toISOString(),
    source: 'SerpApi',
    sample_urls: [],
    confidence_score: 0.92,
    tags: ['electronics', 'entertainment', 'tv'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];

export const mockCategories: Category[] = [
  { id: 1, name: 'Kitchen', parent_id: null, description: 'Kitchen appliances and utensils', icon: '🍳', created_at: new Date().toISOString() },
  { id: 2, name: 'Living Room', parent_id: null, description: 'Living room furniture and electronics', icon: '🛋️', created_at: new Date().toISOString() },
  { id: 3, name: 'Bedroom', parent_id: null, description: 'Bedroom furniture and accessories', icon: '🛏️', created_at: new Date().toISOString() },
  { id: 4, name: 'Bathroom', parent_id: null, description: 'Bathroom fixtures and accessories', icon: '🚿', created_at: new Date().toISOString() },
  { id: 5, name: 'Garden', parent_id: null, description: 'Garden tools and outdoor equipment', icon: '🌳', created_at: new Date().toISOString() },
  { id: 6, name: 'Laundry', parent_id: null, description: 'Laundry appliances and accessories', icon: '🧺', created_at: new Date().toISOString() },
  { id: 7, name: 'Electronics', parent_id: null, description: 'General electronics and gadgets', icon: '📱', created_at: new Date().toISOString() },
  { id: 8, name: 'Cleaning', parent_id: null, description: 'Cleaning equipment and supplies', icon: '🧹', created_at: new Date().toISOString() },
];

export const mockDashboardStats: DashboardStats = {
  total_items: mockItems.length,
  updated_today: 5,
  updated_this_week: 8,
  avg_confidence: 0.86,
  total_categories: mockCategories.length,
  last_update_time: new Date().toISOString(),
};
